const count = (value) =>
  Number.isSafeInteger(value) && value >= 0 ? value : null;
const fraction = (value) =>
  Number.isFinite(value) && value >= 0 && value <= 1 ? value : null;
const aliases = {
  scheduledCents: "scheduled_cents",
  ruledCents: "ruled_cents",
  leavesTotal: "leaves_total",
  leavesRuled: "leaves_ruled",
  leavesPartial: "leaves_partial",
  // D14: o que segue a origem, o que fica sem distribuição e a referência da obra, em valor
  // e em serviços. Ausentes num payload gravado antes da origem existir: viram `null`.
  followsBaseCents: "follows_base_cents",
  undistributedCents: "undistributed_cents",
  referenceCents: "reference_cents",
  leavesFollowsBase: "leaves_follows_base",
  leavesUndistributed: "leaves_undistributed",
};
export const normalizeDisbursementCoverage = (value) => {
  if (!value || typeof value !== "object" || Array.isArray(value)) return null;
  const result = Object.fromEntries(
    Object.entries(aliases).map(([key, alias]) => [
      key,
      count(Object.hasOwn(value, key) ? value[key] : value[alias]),
    ]),
  );
  const orphanRules = Object.hasOwn(value, "orphanRules")
    ? value.orphanRules
    : value.orphan_rules;
  return {
    ...result,
    percentage: fraction(value.percentage),
    distributedPercentage: fraction(
      Object.hasOwn(value, "distributedPercentage")
        ? value.distributedPercentage
        : value.distributed_percentage,
    ),
    orphanRules: Array.isArray(orphanRules) ? orphanRules : [],
  };
};

/**
 * A cobertura que a tela apresenta (D14): o valor com distribuição no tempo sobre a
 * referência da obra. `null` quando o payload não traz a referência (curva gerada antes de a
 * origem existir) — a tela então cai na leitura antiga, a cobertura de regras.
 */
export const hasOriginCoverage = (coverage) =>
  coverage?.referenceCents != null &&
  coverage?.followsBaseCents != null &&
  coverage?.ruledCents != null &&
  coverage?.undistributedCents != null;

const plural = (value, one, many) =>
  `${value.toLocaleString("pt-BR")} ${value === 1 ? one : many}`;

/**
 * A frase de serviços da cobertura. Com a divisão da origem: quantos serviços seguem a
 * origem, quantos têm regra própria (inteira ou parcial) e quantos estão sem distribuição.
 * `followsLabel` diz a que origem eles seguem ("o desembolso do ERP"); sem ele, "a origem".
 * Sem a divisão (payload antigo), a leitura antiga, que fala de regra e de "à vista".
 */
export const coverageServicesLabel = (coverage, { followsLabel = "a origem" } = {}) => {
  if (
    hasOriginCoverage(coverage) &&
    coverage.leavesFollowsBase != null &&
    coverage.leavesRuled != null &&
    coverage.leavesPartial != null &&
    coverage.leavesUndistributed != null
  ) {
    const withRule = coverage.leavesRuled + coverage.leavesPartial;
    return `${plural(coverage.leavesFollowsBase, "serviço segue", "serviços seguem")} ${followsLabel}, ${plural(
      withRule,
      "tem regra própria",
      "têm regra própria",
    )} e ${plural(coverage.leavesUndistributed, "está sem distribuição", "estão sem distribuição")}.`;
  }
  return coverage?.leavesRuled == null || coverage?.leavesTotal == null
    ? "Contagem de serviços indisponível."
    : `${coverage.leavesRuled.toLocaleString(
        "pt-BR",
      )} de ${coverage.leavesTotal.toLocaleString(
        "pt-BR",
      )} serviços já têm regra; o restante segue à vista.`;
};
